export const Transmission = {
  MANUAL: 'Manual',
  AUTOMATIC: 'Automatic',
  SEMI_AUTOMATIC: 'Semi-Automatic',
  CVT: 'CVT',
  DUAL_CLUTCH: 'Dual-clutch',
};

export const VehicleType = {
  CAR: 'Car',
  COMMERCIAL: 'Commercial',
};

export const Fuel = {
  PETROL: 'Petrol',
  DIESEL: 'Diesel',
  ELECTRIC: 'Electric',
  HYBRID: 'Hybrid',
  HYDROGEN: 'Hydrogen',
  NATURAL_GAS: 'Natural Gas',
  BI_FUEL: 'Bi Fuel',
};

export const Doors = [1, 2, 3, 4, 5];

export const BodyType = {
  HATCHBACK: 'Hatchback',
  SALOON: 'Saloon',
  ESTATE: 'Estate',
  SUV: 'SUV',
  COUPE: 'Coupe',
  CONVERTIBLE: 'Convertible',
  MPV: 'MPV',
  PICKUP: 'Pickup',
  VAN: 'Van',
  OTHER: 'Other',
};

export const Color = {
  BLACK: 'Black',
  BLUE: 'Blue',
  GREY: 'Grey',
  WHITE: 'White',
  SILVER: 'Silver',
  RED: 'Red',
  GREEN: 'Green',
  BEIGE: 'Beige',
  BRONZE: 'Bronze',
  BROWN: 'Brown',
  GOLD: 'Gold',
  MULTICOLOUR: 'Multicolour',
  ORANGE: 'Orange',
  PINK: 'Pink',
  PURPLE: 'Purple',
  YELLOW: 'Yellow',
};

export default {
  Transmission,
  Fuel,
  Doors,
};
